import { Fragment } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { ExamAssessment } from "../Models/CCAssessment";

interface IProps {
    examAssessment: ExamAssessment;
}

export function ExamAssessmentCard(props: IProps) {
    var examDueHeader = "Exam Due";

    const getFormattedDueDate = () => {
        if (isNaN(Date.parse(props.examAssessment.dueDate))) return props.examAssessment.dueDate;

        return getDateWithOffset(props.examAssessment.dueDate).getFullYear().toString();
    }

    return (
            <Fragment>
                <Row className="align-items-end">
                    <Col>
                        <Form.Group controlId="licenseNumber">
                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller"></Form.Label>
                            <Form.Text className="font-weight-bolder mb-1 pp-font-size-smaller">{props.examAssessment.certificationName.toUpperCase()}</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="dueDate">
                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">{examDueHeader}</Form.Label>
                            <Form.Text>{getFormattedDueDate()}</Form.Text>                    
                        </Form.Group>
                    </Col>
                    <Col>
                    <span>&nbsp;</span>
                    </Col>
                </Row>
            <hr className="mt-0"/>
            </Fragment>
        );

}

export default ExamAssessmentCard;